import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import { t } from '@/i18n';

const PREFIX = 'pages.application_championship_stage_standings.breadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  { label: t(`${PREFIX}.label1`), link: '/application' },
  { label: t(`${PREFIX}.label2`), link: '/application/championships' },
  { label: t(`${PREFIX}.label3`) },
];
